module.exports = __webpack_public_path__ + "static/media/股神历练@2x.b07578be.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_149/img/股神历练@2x.png
// module id = 1460
// module chunks = 0